module.exports = __webpack_public_path__ + "static/media/aadhaar-validation.cc7634e0.png";